import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../shared/api/supabase';
import { getScriptAnalysis } from './api';

export const scriptAnalysisKeys = {
  one: (projectId: string) => ['script-analysis', projectId] as const,
};

/** The analysis of a project's script, if it has one. */
export const useScriptAnalysis = (projectId: string, enabled = true) =>
  useQuery({
    queryKey: scriptAnalysisKeys.one(projectId),
    queryFn: () => getScriptAnalysis(supabase, projectId),
    enabled,
  });
